import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _BuildingSidebar;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
/* eslint "array-callback-return": "warn" */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx } from '@instructure/emotion';
import SidebarItem from './SidebarItem';
import Stimulus from './Stimulus';
import Sidebar from '../../../../common/components/layout/sidebar/Sidebar';
import generateDisplayPositions from '../../../../common/util/generateDisplayPositions';
import { extractTextFromHtml } from '@instructure/quiz-interactions';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { SIDEBAR_ITEM_REF, withStyleOverrides } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/format-message';
export var BuildingSidebar = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_BuildingSidebar = /*#__PURE__*/function (_Component) {
  function BuildingSidebar() {
    var _this2;
    _classCallCheck(this, BuildingSidebar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BuildingSidebar, [].concat(args));
    // NOTE: we use a higher order function here only so that we can match
    // the props provided to our common interface from the TakingSidebar.
    _defineProperty(_this2, "scrollToItem", function (_) {
      return function (scrollKey) {
        _this2.props.scrollToItem(scrollKey);
      };
    });
    // need to pass isOver this way to force a rerender when it changes,
    // since only this function is passed down for rendering items in stimuli
    _defineProperty(_this2, "renderItem", function () {
      var isOver = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props.isOver;
      return function (quizEntry, displayPosition, sidebarIsOpen) {
        return jsx(SidebarItem, {
          key: _this2.setKey(quizEntry.id),
          ref: _this2.setRef(quizEntry.id),
          inStimulus: quizEntry.isInStimulus,
          draggingInSidebar: isOver,
          isTemporary: _this2.isTemporary(quizEntry),
          itemBody: _this2.getItemBody(quizEntry),
          itemName: _this2.getItemName(quizEntry),
          itemId: quizEntry.id,
          pointsPossible: quizEntry.pointsPossible,
          displayPosition: displayPosition,
          quizEntry: quizEntry,
          quizEntries: _this2.props.quizEntries,
          sidebarOpen: sidebarIsOpen
        });
      };
    });
    _defineProperty(_this2, "renderBankEntry", function (quizEntry, displayPosition, sidebarIsOpen) {
      if (quizEntry.hasStimulus) {
        return _this2.renderStimulus(quizEntry, displayPosition, sidebarIsOpen);
      }
      return _this2.renderItem()(quizEntry, displayPosition, sidebarIsOpen);
    });
    _defineProperty(_this2, "storeStartQuizEntriesRef", function (node) {
      _this2.startQuizEntries = node;
    });
    _defineProperty(_this2, "storeEndQuizEntriesRef", function (node) {
      _this2.endQuizEntries = node;
    });
    return _this2;
  }
  _inherits(BuildingSidebar, _Component);
  return _createClass(BuildingSidebar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "getItemBody",
    value: function getItemBody(quizEntry) {
      switch (quizEntry.entryType) {
        case 'Item':
        case 'BankEntry':
          return extractTextFromHtml(quizEntry.getItem().getItemBody() || '');
        case 'Bank':
          return quizEntry.getEntry().title;
      }
      return '';
    }
  }, {
    key: "getItemName",
    value: function getItemName(quizEntry) {
      switch (quizEntry.entryType) {
        case 'Item':
        case 'BankEntry':
          return quizEntry.getItem().getInteractionType().name;
        case 'Bank':
          return t('Banked Content');
      }
    }
  }, {
    key: "isTemporary",
    value: function isTemporary(quizEntry) {
      if (quizEntry.entryType !== 'Item') {
        return false;
      }
      var item = quizEntry.getEntry();
      return item.getWorkingInstance().isTemporary();
    }
  }, {
    key: "setKey",
    value: function setKey(quizEntryId) {
      return "".concat(SIDEBAR_ITEM_REF, "_").concat(quizEntryId);
    }
  }, {
    key: "setRef",
    value: function setRef(quizEntryId) {
      var _this3 = this;
      return function (node) {
        _this3[_this3.setKey(quizEntryId)] = node;
      };
    }
  }, {
    key: "renderStimulus",
    value: function renderStimulus(quizEntry, displayPosition, sidebarIsOpen) {
      return jsx(Stimulus, {
        key: this.setKey(quizEntry.id),
        ref: this.setRef(quizEntry.id),
        displayPosition: displayPosition,
        itemId: quizEntry.id,
        draggingInSidebar: this.props.isOver,
        renderSidebarItem: this.renderItem(),
        quizEntry: quizEntry,
        quizEntries: this.props.quizEntries,
        sidebarOpen: sidebarIsOpen
      });
    }
  }, {
    key: "renderSidebarItems",
    value: function renderSidebarItems(sidebarIsOpen) {
      var _this4 = this;
      var quizEntries = this.props.quizEntries;
      return generateDisplayPositions(quizEntries).reduce(function (renderedQuizEntries, quizEntry) {
        var entryType = quizEntry.record.entryType;
        if (entryType === 'Item' || entryType === 'Bank') {
          var itemOrBank = _this4.renderItem()(quizEntry.record, quizEntry.displayPosition, sidebarIsOpen);
          renderedQuizEntries.push(itemOrBank);
        } else if (entryType === 'BankEntry') {
          var bankEntry = _this4.renderBankEntry(quizEntry.record, quizEntry.displayPosition, sidebarIsOpen);
          renderedQuizEntries.push(bankEntry);
        } else if (entryType === 'Stimulus') {
          var stimulus = _this4.renderStimulus(quizEntry.record, quizEntry.displayPosition, sidebarIsOpen);
          renderedQuizEntries.push(stimulus);
        }
        return renderedQuizEntries;
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var openClass = !this.props.sidebarOpen ? 'sidebarIsClosed' : 'sidebarIsOpen';
      var isOverClass = !this.props.isOver ? 'hide' : '';
      return this.props.connectDropTarget(/* React DnD requires a native element node like our div below */
      jsx("div", {
        style: {
          display: 'flex'
        }
      }, jsx("div", {
        className: openClass
      }, jsx(Sidebar, {
        role: this.props.role,
        scrollToItem: this.scrollToItem,
        sidebarOpen: this.props.sidebarOpen,
        toggleSidebar: this.props.toggleSidebar,
        screenreaderNotification: this.props.screenreaderNotification,
        totalPointsPossible: this.props.totalPointsPossible
      }, jsx("div", {
        ref: this.storeStartQuizEntriesRef
      }), jsx("div", {
        className: "closedItems",
        css: this.props.styles.closedItems
      }, this.renderSidebarItems(false)), jsx("div", {
        className: "openItems",
        css: this.props.styles.openItems
      }, this.renderSidebarItems(true)), jsx("div", {
        ref: this.storeEndQuizEntriesRef,
        className: isOverClass,
        css: this.props.styles.bottomPadding
      })))));
    }
  }]);
}(Component), _defineProperty(_BuildingSidebar, "displayName", 'BuildingSidebar'), _defineProperty(_BuildingSidebar, "componentId", "Quizzes".concat(_BuildingSidebar.displayName)), _defineProperty(_BuildingSidebar, "propTypes", {
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool,
  quizEntries: ImmutablePropTypes.list.isRequired,
  role: PropTypes.string,
  scrollToItem: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  totalPointsPossible: PropTypes.number.isRequired,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_BuildingSidebar, "defaultProps", {
  isOver: false,
  role: 'navigation'
}), _BuildingSidebar)) || _class);
export default BuildingSidebar;